import React from "react";
import "../style/Home.css";
import cfdFailed from "../static/images/NoCFDResults.png"
import { Container } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button, ButtonGroup } from "react-bootstrap";
import { useState, useReducer, useEffect } from "react";
import VTKScene from "./VTKScene";
import CFILinePlot from "./CFILinePlot";
import DcmCarousel from "./DcmCarousel";
import SimulationMovie from "./SimulationMovie";
import SupervisorAssessmentResults from "./SupervisorAssessmentResults";
import { ToggleButton } from "react-bootstrap";


const initialState = {
    simA: undefined,
    simB: undefined,
    plotDataObjA: undefined,
    plotDataObjB: undefined
};


const selectReducer = (state, action) => {
    let newState = { ...state };
    switch (action.type) {
        case 'updateA':
            state.simulations.forEach((iSimulation) => {
                if (iSimulation.id.toString() === action.simValue.toString()) {
                    if (iSimulation.hasDicoms) {
                        console.log('Simulations is:', iSimulation);
                        newState.simA = iSimulation;
                    };
                    try {
                        newState.plotDataObjA = {};
                        newState.plotDataObjA.U = {
                            xArray: newState.simA.data.d,
                            yArray: newState.simA.data.U,
                            xLabel: newState.simA.data.Labels.d,
                            yLabel: newState.simA.data.Labels.U,
                            color: '#FF1100',
                            step: 5,
                            dataLabel: "Velocity " + newState.simA.traineeName + " " + newState.simA.simulationID
                        };
                        newState.plotDataObjA.p = {
                            xArray: newState.simA.data.d,
                            yArray: newState.simA.data.p,
                            xLabel: newState.simA.data.Labels.d,
                            yLabel: newState.simA.data.Labels.p,
                            color: '#F800FF',
                            step: 0.2,
                            dataLabel: "Pressure " + newState.simA.traineeName + " " + newState.simA.simulationID
                        };
                    } catch (error) {
                        newState.plotDataObjA = false;
                    };
                }
            }
            );
            return newState;

        case 'updateB':
            state.simulations.forEach((iSimulation) => {
                if (iSimulation.id.toString() === action.simValue.toString()) {
                    if (iSimulation.hasDicoms) {
                        newState.simB = iSimulation;
                    };
                    try {
                        newState.plotDataObjB = {}
                        newState.plotDataObjB.U = {
                            xArray: newState.simB.data.d,
                            yArray: newState.simB.data.U,
                            xLabel: newState.simB.data.Labels.d,
                            yLabel: newState.simB.data.Labels.U,
                            color: '#0008FF',
                            step: 5,
                            dataLabel: "Velocity " + newState.simB.traineeName + " " + newState.simB.simulationID
                        };
                        newState.plotDataObjB.p = {
                            xArray: newState.simB.data.d,
                            yArray: newState.simB.data.p,
                            xLabel: newState.simB.data.Labels.d,
                            yLabel: newState.simB.data.Labels.p,
                            color: '#00D8FF',
                            step: 0.2,
                            dataLabel: "Pressure " + newState.simB.traineeName + " " + newState.simB.simulationID
                        };
                    } catch (error) {
                        newState.plotDataObjB = false;
                    };
                }
            }
            );


            return newState;
        default:
            return newState;
    }

}



const SupervisorStudy = ( { study, user }) => {
    
    const [dispState, dispatchState] = useReducer(selectReducer, {
        ...initialState,
        simulations: study.simulations
    });

    const [simulationsToChooseFrom, setSimulationsToChooseFrom] = useState(study.simulations);
    const [filteredTrainee, setFilteredTrainee] = useState('ALL');
    const [selA, setSelA] = useState('');
    const [selB, setSelB] = useState('');
    const [simAB, setSimAB] = useState([undefined, undefined, undefined, undefined]);
    const [isReady, setIsReady] = useState(false);
    const [isReadyOverView, setIsReadyOverView] = useState(true);
    const [playPause, setPlayPause] = useState(false); // true is play | false is pause
    const [VelOrPress, setVelOrPress] = useState('VELOCITY');

    const handleSubmitSubj = (event) => {
        event.preventDefault();
        setSimAB([undefined, undefined, undefined, undefined]);
        setFilteredTrainee(undefined);
        setIsReady(false);
        setSelA('');
        setSelB('');
        const traineeIDSel = event.target.elements[`TraineeSelect${study.studyID}`].value;
        setFilteredTrainee(traineeIDSel);
        if (traineeIDSel === "ALL") {
            setSimulationsToChooseFrom(study.simulations);
        } else {
            setSimulationsToChooseFrom(traineeSims(parseInt(traineeIDSel)));
        }
    };

    const handleSubmitSims = (event) => {
        event.preventDefault();
        setIsReady(false);
        const valueA = event.target.elements[`SimASelect${study.studyID}`].value;
        const valueB = event.target.elements[`SimBSelect${study.studyID}`].value;
        if (valueA && valueB && !valueA.includes('Choose') && !valueB.includes('Choose')) {
            setSimAB([dispState.simA, dispState.simB, dispState.plotDataObjA, dispState.plotDataObjB]);
        }
    };

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            simAB[0] && simAB[1] && setIsReady(true);
        }
        return () => {
            mounted = false;
        };
    }, [simAB]);

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            filteredTrainee && setIsReadyOverView(true);
        }
        return () => {
            mounted = false;
        };
    }, [filteredTrainee]);

    const handleChangeA = event => {
        try {
            setSelA(event.target.value);
            dispatchState({
                type: 'updateA',
                simValue: event.target.value,
            });
        } catch (error) {
            console.error('Error in handleChangeA:', error);
        }
    };

    const handleChangeB = event => {
        try {
            setSelB(event.target.value);
            dispatchState({
                type: 'updateB',
                simValue: event.target.value,
            });
        } catch (error) {
            console.error('Error in handleChangeB:', error);
        }
    };

    const switchVelPress = event => {
        if (VelOrPress === 'VELOCITY') {
            setVelOrPress('PRESSURE');
        }
        else {
            setVelOrPress('VELOCITY');
        }
    }

    const playCarousel = event => {
        setPlayPause(!playPause);
    }

    const changeFiltered = (filterVal) => {
        setIsReadyOverView(false);
        setFilteredTrainee(filterVal);
    }

    const traineeSims = (traineeID) => {
        try {
            let sims = [];
            study.simulations.forEach(iSimulation => {
                if (iSimulation.trainee_id === traineeID) {
                    iSimulation.hasDicoms && sims.push(iSimulation);
                }
            });
            return sims;
        } catch (error) {
            console.error('Error in traineeSims:', error);
            return [];
        }
    };

    
    return (
        <Container className="container">

            <h3>Supervisor comparison of {study.studyName}</h3>

            <Row>
                <Form onSubmit={handleSubmitSubj} >
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formSupStudyTrainee">
                            <Form.Label>Compare single or all trainees</Form.Label>
                            <Form.Select size="sm" id={"TraineeSelect"+study.studyID} value={filteredTrainee} onChange={(event) => changeFiltered(event.target.value)}>
                                <option key="ChooseAll" value="ALL">Filter ALL</option>
                                {study.traineeNames.map(
                                    (iTraineeName, i) =>
                                    (
                                        <option key={'Trainee' + iTraineeName} value={study.trainee_ids[i]}>Filter {iTraineeName}</option>
                                    )
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formSupStudySubmit">
                            <Button type="submit" className="mt-5">
                                Update
                            </Button>
                        </Form.Group>
                    </Row>
                </Form>
            </Row>
            <Row>
                <Form onSubmit={handleSubmitSims} >
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCFDA">
                            <Form.Label>Simulation A</Form.Label>
                            <Form.Select size="sm" id={"SimASelect"+study.studyID} onChange={handleChangeA} value={selA}>
                                <option key="ChooseA" value={''}>Choose Simulation A</option>
                                {simulationsToChooseFrom.map(
                                    (iSimulation) =>
                                        iSimulation.hasDicoms && (
                                            <option key={'A' + iSimulation.id} value={iSimulation.id}>{iSimulation.traineeName+" "+iSimulation.simulationID}</option>
                                        )
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCFDB">
                            <Form.Label>Simulation B</Form.Label>
                            <Form.Select size="sm" id={"SimBSelect"+study.studyID} onChange={handleChangeB} value={selB}>
                                <option key="ChooseB" value={''}>Choose Simulation B</option>
                                {simulationsToChooseFrom.map(
                                    (iSimulation) =>
                                        iSimulation.hasDicoms && (
                                            <option key={'B' + iSimulation.id} value={iSimulation.id}>{iSimulation.traineeName+" "+iSimulation.simulationID}</option>
                                        )
                                )}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCFDSubmit">
                            <Button type="submit" className="mt-5">
                                Update
                            </Button>
                        </Form.Group>
                    </Row>
                </Form>
            </Row>
            
            {isReadyOverView &&
                <Row className="border border-dark rounded-2 my-3">
                    {
                        <SupervisorAssessmentResults study={study} supervisor={user} filterTraineeID={filteredTrainee}></SupervisorAssessmentResults>
                    }
                </Row>
            }

            {isReady &&
                <Container>
                    <div className="border border-dark rounded-2 m-3">
                        <Row className="m-1">
                            <Col>
                                <Row>
                                    <DcmCarousel id="CmpDcmA" simulation={simAB[0]} playing={playPause} interactive={false}></DcmCarousel>
                                </Row>
                                <Row>
                                    <figcaption>{simAB[0].traineeName+" "+simAB[0].simulationID}</figcaption>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <DcmCarousel id="CmpDcmB" simulation={simAB[1]} playing={playPause} interactive={false}></DcmCarousel>
                                </Row>
                                <Row>
                                    <figcaption>{simAB[1].traineeName+" "+simAB[1].simulationID}</figcaption>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <ButtonGroup aria-label="Carousel-buttongroup">
                                <Button variant="primary" onClick={playCarousel}>{playPause ? "Pause" : "Play"}</Button>
                                {/* <Button variant="primary" onClick={resetSync}>Reset syncronisation</Button> */}
                            </ButtonGroup>
                        </Row>
                    </div>
                        <div className="border border-dark rounded-2 m-3">
                            <Row className="my-1">
                                <Col>
                                    {simAB[2] ?
                                        VelOrPress === 'VELOCITY' ?
                                            <VTKScene id="CmpVTKA-Vel" key="CmpVTKA-Vel" url={'/api/download/trainee/' + simAB[0].id + '/VELOCITY'} showButtons={false} viewWidth={500} ></VTKScene>
                                            :
                                            <VTKScene id="CmpVTKA-Press" key="CmpVTKA-Press" url={'/api/download/trainee/' + simAB[0].id + '/PRESSURE'} showButtons={false} viewWidth={500} ></VTKScene>
                                        :
                                        <img src={cfdFailed} className="img-thumbnail" alt="no flow results"></img>
                                    }                                
                                </Col>
                                <Col>
                                    {simAB[3] ?
                                        VelOrPress === 'VELOCITY' ?
                                            <VTKScene id="CmpVTKB-Vel" key="CmpVTKB-Vel" url={'/api/download/trainee/' + simAB[1].id + '/VELOCITY'} showButtons={false} viewWidth={500} ></VTKScene>
                                            :
                                            <VTKScene id="CmpVTKB-Press" key="CmpVTKB-Press" url={'/api/download/trainee/' + simAB[1].id + '/PRESSURE'} showButtons={false} viewWidth={500} ></VTKScene>
                                        :
                                        <img src={cfdFailed} className="img-thumbnail" alt="no flow results"></img>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <figcaption>{simAB[0].traineeName+" "+simAB[0].simulationID}</figcaption>
                                </Col>
                                <Col>
                                    <figcaption>{simAB[1].traineeName+" "+simAB[1].simulationID}</figcaption>
                                </Col>
                            </Row>
                            <Row>
                                <ButtonGroup aria-label="VTKScene-buttongroup">
                                    <ToggleButton
                                        id="toggle-check-vel"
                                        type="checkbox"
                                        variant={VelOrPress === 'VELOCITY' ? "primary" : "outline-primary"}
                                        checked={VelOrPress === 'VELOCITY'}
                                        value="1"
                                        onChange={(e) => switchVelPress(e.currentTarget.checked)}>
                                        VELOCITY
                                    </ToggleButton>
                                    <ToggleButton
                                        id="toggle-check-press"
                                        type="checkbox"
                                        variant={VelOrPress === 'PRESSURE' ? "primary" : "outline-primary"}
                                        checked={VelOrPress === 'PRESSURE'}
                                        value="1"
                                        onChange={(e) => switchVelPress(e.currentTarget.checked)}>
                                        PRESSURE
                                    </ToggleButton>
                                </ButtonGroup>
                            </Row>
                        </div>
                    <Row className="my-3">
                        {simAB[2] || simAB[3] ?
                        <Col>
                            {VelOrPress === 'VELOCITY' && (simAB[2]?.U || simAB[3]?.U) ?
                                <CFILinePlot id="CmpLinePlotBU" dataObjA={[simAB[2]?.U, simAB[3]?.U].filter(Boolean)}></CFILinePlot>
                                :
                                <CFILinePlot id="CmpLinePlotBp" dataObjA={[simAB[2]?.p, simAB[3]?.p].filter(Boolean)}></CFILinePlot>
                            }
                        </Col>
                        :
                        <p>No flow dynamics results to plot</p>
                        }
                    </Row>
                    <div className="border border-dark rounded-2 m-3">
                    <Row className="my-1">
                        <Row>
                            <Col>
                                { simAB[0].stitchesVTKJS ? 
                                <VTKScene id="CmpVTKA-StitV" key="CmpVTKA-StitV" url={'/api/download/trainee/' + simAB[0].id + '/STITCHESVTKJS'} showButtons={false} viewWidth={500} ></VTKScene>
                                :
                                    <p>No stitches results available for {simAB[0].traineeName+" "+simAB[0].simulationID}</p>
                                }
                            </Col>
                            <Col>
                                { simAB[1].stitchesVTKJS ? 
                                <VTKScene id="CmpVTKB-StitV" key="CmpVTKB-StitV" url={'/api/download/trainee/' + simAB[1].id + '/STITCHESVTKJS'} showButtons={false} viewWidth={500} ></VTKScene>
                                :
                                    <p>No stitches results available for {simAB[1].traineeName+" "+simAB[1].simulationID}</p>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                { simAB[0].stitchesFile ? 
                                    <img src={'/api/download/trainee/' + simAB[0].id + '/STITCHESPNG' } className="img-thumbnail" alt="no stitches results"></img>
                                :
                                    <p>No stitches results available for {simAB[0].traineeName+" "+simAB[0].simulationID}</p>
                                }
                            </Col>
                            <Col>
                                { simAB[1].stitchesFile ? 
                                    <img src={'/api/download/trainee/' + simAB[1].id + '/STITCHESPNG' } className="img-thumbnail" alt="no stitches results"></img>
                                :
                                    <p>No stitches results available for {simAB[1].traineeName+" "+simAB[1].simulationID}</p>
                                }
                            </Col>
                        </Row>
                    </Row>
                    <Row>
                        <Col>
                            <figcaption>{simAB[0].traineeName+" "+simAB[0].simulationID}</figcaption>
                        </Col>
                        <Col>
                            <figcaption>{simAB[1].traineeName+" "+simAB[1].simulationID}</figcaption>
                        </Col>
                    </Row>
                    </div>
                    <div className="border border-dark rounded-2 m-3">
                        <Row className="my-2">
                            { simAB[0].simulationMovieFilename ? 
                            <div>
                                <Row>
                                    <SimulationMovie key={'CmpSimMovieA'+user.id+simAB[0].id} simulation={simAB[0]}></SimulationMovie>
                                </Row>
                                <Row>
                                    <figcaption>{simAB[0].traineeName+" "+simAB[0].simulationID}</figcaption>
                                </Row>
                            </div>
                            :
                            <p>No movie available for {simAB[0].traineeName+" "+simAB[0].simulationID}</p>
                            }
                        </Row>
                        <Row className="my-2">
                            { simAB[1].simulationMovieFilename ? 
                            <div>
                            <Row>
                                <SimulationMovie key={'CmpSimMovieA'+user.id+simAB[1].id} simulation={simAB[1]}></SimulationMovie>
                            </Row>
                            <Row>
                                <figcaption>{simAB[1].traineeName+" "+simAB[1].simulationID}</figcaption>
                            </Row>
                            </div>
                            :
                            <p>No movie available for {simAB[1].traineeName+" "+simAB[1].simulationID}</p>
                            }
                        </Row>
                    </div>
                </Container>
                // : errorMsg &&
                // <p>{errorMsg}</p>
            }


        </Container>
    );
}

export default SupervisorStudy;